function hasTimelineEvents(events, timelineStatus, isPinnedEngagementDisplayed) {
  return !!(events && events.size > 0 && events.findIndex(el => el.get('etype')) > 0) || timelineStatus.get('hasMore') || timelineStatus.get('isFetching') || isPinnedEngagementDisplayed;
}
export default hasTimelineEvents;